import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { MenuGroup, WebpagemenuService } from '@app/core/components/webpagemenu/webpagemenu.service';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetWebPageLinkParams, WebPageLinkGet, WebPageService } from '@app/services/web-page.service';

@Component({
    selector: 'tt-web-page-link',
    templateUrl: './web-page-link.component.html',
    styleUrls: ['./web-page-link.component.css'],
    standalone: false,
})
export class WebPageLinkComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetWebPageLinkParams;

    public get?: WebPageLinkGet;

    public grid?: GridOptions;

    public menuGroups: MenuGroup[] = [];

    constructor(
        private webPage: WebPageService,
        private webpagemenu: WebpagemenuService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public readGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_webpagelink_grid')
                .setLoadDataFunction({ method: 3488, parameters: () => this.params })
                .addToolbarButton({
                    name: 'webpagelink_set_menugrp_keyno',
                    text: 'webpagelink_set_menugrp_keyno',
                    translate: true,
                    icon: 'fa-plus',
                    cssClass: 'tt-button tt-button--success im-grid-btn-xs-r',
                    func: () => this.setMenuGroupToRows(),
                });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    public async setMenuGroupToRows() {
        const selectedRows = this.grid?.gridfunc?.getIsSelectedRows() ?? [];

        if (selectedRows.length === 0 || !this.get) return;

        let count = 0;
        const progressModal = this.modal.openProgressDialog({ rememberId: 'w_cuttingplanpoadd_progressmodal', value: count, max: selectedRows.length });

        for (let row of selectedRows) {
            const { errorcode, errormessage } = await this.webPage.setWebPageLinkToMenuGroup({ p2_webpagelink_keyno: row['p2_webpagelink_keyno'], menugrp_keyno: this.get.menugrp_keyno });

            if ('' + errorcode !== '0') {
                progressModal.updateStatus('invalid');
                progressModal.updateInvalidText(errormessage);
                break;
            }

            count = count + 1;
            progressModal.updateValue(count);
        }

        if (count === selectedRows.length) {
            progressModal.updateStatus('finish');
        }

        this.readGrid();
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.webPage.getWebPageLink(this.params);
        }
    }

    private async loadMenuGroups() {
        this.menuGroups = await this.webpagemenu.getWebpagemenuGroups();
    }

    private async init() {
        this.readGrid();
        this.loadMenuGroups();
        await this.loadGet();
        this.navigator?.setHeading?.(this.get?.webpage_heading ?? '');
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
        }
    }
}
